export default __webpack_public_path__ + "static/media/190629_190332_IMG_9504.e1a2db47.jpg";